const LABELS_CONFIG = {
  YOU_NEED_THE_PACKAGE: 'packages.youNeedPackagetoWatchContent',
  ENTER_PIN_HINT: 'packages.enterPinOnNextScreen',
  TERMS_CONDITION: 'packages.termsAndCondition',
  PURCHASE_UNSUCCESSFUL: 'packages.purchaseUnsuccessful',
  NO_INTERNET_CONNECTION: 'nointernet.message',
  SOMETHING_NOT_RIGHT: 'packages.somethingNotRight',
  ENTER_PIN_TO_SUB: 'packages.enterPinToSub',
  THANKS_TO_GOT: 'packages.web.thanksToGot',
  AGREEING_TERMS: 'packages.web.agreeingTerms',
  UPDATED_SUBSCRIPTION: 'packages.updatedSubscription',
  ROLLING_MONTHLY_PLAN: 'packages.rollingMonthlyPlan',
  ADD_OFFER_FOR: 'packages.addOfferTitleFor',
  INVALID_CUSTOMER_ACCOUNT_FOR_PURCHASE: 'packages.web.invalidCustomerAccountForPurchase',
  OFFER_NOT_FOUND: 'packages.addCustomerPackageOfferNotFound',
  PKG_PURCHASE_FAILER_MSG: 'packages.pkgPurchaseFailureMsg',
  ACCOUNT_IN_ARREARS: 'packages.customerAccountInArrearsError',
  ACOUNT_OVERDUE_MSG: 'packages.accountOverdueMessage',
  DUPLICATE_PURCHASE: 'packages.addCustomerPackageDuplicateError',
  PACKAGE_REJECTED: 'packages.web.addCustomerPackageRejectedError',
  MANAGE_PACKAGE: 'packages.managePackages',
  CANCEL_PKG_HINT: 'packages.web.cancelPkgHint',
  ALREADY_IN_SUBSCRIPTION: 'packages.web.alreadyInSub',
  NEED_PIN_TO_ADD_PKG: 'packages.web.needPinToAddPkg',
  ADD_PKG_ON_ROLLING_MONTHLY_PLAN: 'packages.web.addPkgOnRollingMonthlyPlan',
  NEED_ACTIVE_ACCOUNT_TO_PURCHASE: 'packages.needActiveAccountToPurchase',
  RESTART_SKY_ACCOUNT: 'packages.restartSkyAccount',
  MANAGE_DEVICE_SUBHEADER: 'manageDevices.subheader',
  MANAGE_DEVICE_NOTE: 'manageDevices.note',
  MANAGE_DEVICE_CURRENT_DEVICE: 'manageDevices.currentDevice',
  MANAGE_DEVICE_DESCRIPTION: 'manageDevices.description',
  MANAGE_DEVICE_OTHER_DEVICES: 'manageDevices.otherDevices',
  MANAGE_DEVICE_SIGN_OUT: 'manageDevices.signOut',
  MANAGE_DEVICE_SIGN_OUT_FROM_ALL: 'manageDevices.signOutFromAll',
  MANAGE_DEVICE_YOUR_DEVICES: 'manageDevices.yourDevices',
  MANAGE_DEVICE_CURRENT_SESSION: 'manageDevices.currentSession',
  MANAGE_DEVICE_MODAL_HEADER: 'manageDevices.modalHeader',
  MANAGE_DEVICE_MODAL_DESCRIPTION: 'manageDevices.modalDescription',
  MANAGE_DEVICE_MODAL_OK: 'manageDevices.modalOk',
  MANAGE_DEVICE_MODAL_CANCEL: 'manageDevices.modalCancel',
  MANAGE_DEVICE_NO_DEVICE_HEADER: 'manageDevices.emptyStateTitle',
  MANAGE_DEVICE_NO_DEVICE_DESCRIPTION: 'manageDevices.emptyStateDescription',
  VOD_COUNTDOWN_MSG: 'ads.vodCountdownMsg',
  TILE_BADGE_UPCOMING: 'tileBadge.upcoming',
  TILE_BADGE_LIVE: 'tileBadge.live',
};
const PKG_SUBSCRIBE_EVENT = {
  ADD_CUSTOMER_PKG_SUCCESS_RESPONSE: 'AddCustomerPackageSuccessResponse',
  INVALID_CUSTOMER_ACCOUNT_FOR_PURCHASE: 'InvalidCustomerAccountForPurchase',
  CUSTOMER_ACCOUNT_IN_ARREARS_ERROR: 'CustomerAccountInArrearsError',
  ADD_CUSTOMER_PKG_REJECTED_RESPONSE: 'AddCustomerPackageRejectedResponse',
  ADD_CUSTOMER_PKG_OFFER_NOT_FOUND: 'AddCustomerPackageOfferNotFound',
  ADD_CUSTOMER_PKG_DUPLICATE_RESPONSE: 'AddCustomerPackageDuplicateResponse',
};
const PURCHASE_FAILURE_REASONS = {
  CONTENT_PURCHASE_API_ERROR: 'Content Purchase Api Connection Fail',
  INVALID_CUSTOMER_ACCOUNT: 'Invalid Customer Account For Purchase',
  CUSTOMER_ACCOUNT_IN_ARREARS: 'Customer Account InArrears Error For Purchase',
  DUPLICATE_CONTENT_PURCHASE: 'Content Purchase Duplicated Error',
  GENERAL_PURCHASE_FAILURE: 'Content Purchase Unsuccessful',
  CUSTOMER_PURCHASE_REJECTED: 'Content Purchase Rejected',
};
const PACKAGE_UPGRADE_EVENTS = {
  PACKAGE_UPGRRADE_COMPLETED: 'Package Upgrade Completed',
  PACKAGE_UPGRRADE_INITIATED: 'Package Upgrade Initiated',
  PACKAGE_UPGRRADE_FAILED: 'Package Upgrade Failed',
  PACKAGE_UPGRRADE_CANCELLED: 'Package Upgrade Cancelled',
};

enum VIEWING_METHODS {
  VOD = 'VodViewingMethod',
  LINEAR = 'LinearViewingMethod',
}
export {
  LABELS_CONFIG,
  PACKAGE_UPGRADE_EVENTS,
  PKG_SUBSCRIBE_EVENT,
  PURCHASE_FAILURE_REASONS,
  VIEWING_METHODS,
};
